import { Injectable } from '@angular/core';
import { ProjectService } from '../../api/services/project.services';
import { Quote, OrderOptionsDto, DeliveryOptionsDto } from '../../api/models/quote';
import { QuoteAdvisories, QuoteAdvisoriesResult } from '../../api/models/quote-advisories';
import { Observable } from 'rxjs/Observable';
import { Worksheet } from '../../api/models/worksheet';
import { of } from 'rxjs/observable/of';
import { QuoteRequest } from '../../api/models/quote-request';

@Injectable()
export class CheckoutService {

  private bomLinesAdvisories: QuoteAdvisories[] = [];

  private bomLinesAdvisoriesResults: QuoteAdvisoriesResult[] = [];

  constructor(
    private projectService: ProjectService
  ) { }

  setBomLinesAdvisories(advisories: QuoteAdvisories[]) {
    this.bomLinesAdvisories = advisories;
  }

  setBomLinesAdvisoriesResults(bomLinesAdvisoriesResults: QuoteAdvisoriesResult[]) {
    this.bomLinesAdvisoriesResults = bomLinesAdvisoriesResults;
  }

  areItemsBackordered(quote: Quote): boolean {
    return quote.orderLines.some(ol => ol.quantity > ol.quantityAvailable);
  }

  getAdvisoriesFromQuote(quote: Quote): QuoteAdvisories[] {
    return quote.orderLines.map(ol => ({ bomLineId: ol.bomLineId, advisoryValue: ol.advisories, isTesscoTuned: ol.isTesscoTuned }));
  }

  getQuote(worksheetId: string, worksheetQuote?: Quote, isQuoted?: boolean): Observable<Quote> {
      const quote = new Quote(worksheetQuote);
      quote.isRealQuote = isQuoted;
      quote.inCheckout = true;
      quote.advisories = worksheetQuote ? worksheetQuote.advisories : this.bomLinesAdvisories;
      quote.orderOptions = worksheetQuote ? new OrderOptionsDto(worksheetQuote.orderOptions) : new OrderOptionsDto();
      quote.hasUserAcceptedTermsAndConditions = worksheetQuote ? worksheetQuote.hasUserAcceptedTermsAndConditions : true;
      quote.shipViaCode = worksheetQuote ? worksheetQuote.shipViaCode : '3';
      quote.deliveryOptions = worksheetQuote ? new DeliveryOptionsDto(worksheetQuote.deliveryOptions) : new DeliveryOptionsDto();

      return this.projectService.submitQuote(worksheetId, quote);
  }

  submitQuote(worksheetId: string, quote: Quote) {
    quote.advisories = this.bomLinesAdvisories;
    return this.projectService.submitQuote(worksheetId, quote);
  }

  submitQuoteV2(worksheetId: string, quoteRequest: QuoteRequest) {
    return this.projectService.submitQuoteV2(quoteRequest);
  }

  submitPayment(poNumber: string, worksheet: Worksheet) {
    if (worksheet.paymentId === null) {
      return this.projectService.submitPayment(poNumber, worksheet.id);
    } else {
      return of([]);
    }
  }

  submitOrder(worksheetId: string) {
      return this.projectService.submitOrder(worksheetId);
  }

  submitOrderV2(worksheetId: string, quoteRequest: QuoteRequest) {
    return this.projectService.submitOrderV2(worksheetId, quoteRequest);
  }

  submitForTesscoReviewV2(worksheetId: string, quoteRequest: QuoteRequest) {
    return this.projectService.submitForTesscoReviewV2(worksheetId, quoteRequest);
  }

  saveBomLineAdvisories() {
    if (this.bomLinesAdvisoriesResults.length > 0) {
      this.projectService.saveBomLineAdvisories(this.bomLinesAdvisoriesResults).subscribe();
    }
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/checkout/checkout.service.ts